import React, { createContext } from 'react';

const TeamContext = createContext();

export default TeamContext;